import React from 'react'
import { SvgIcon } from '@mui/material'


export const TestExamIcon = ({ sx, ...props }) => {
    return (
        <SvgIcon viewBox='0 0 30 26' {...{ sx: sx?.color ? { ...sx, stroke: sx.color, color: 'rgba(0,0,0,0.01)' } : sx, ...props }}>
            <path xmlns="http://www.w3.org/2000/svg" d="M13.5132 4.94046L28.5258 4.9416M13.5132 14.402L28.5258 14.4031M13.5132 23.8635L28.5258 23.8646M1.50317 14.3144L3.8128 16.7674L9.00947 11.2481M1.50317 4.85285L3.8128 7.30584L9.00947 1.78662M3.75506 23.8635H3.77008M4.50569 23.8635C4.50569 24.2989 4.16962 24.652 3.75506 24.652C3.3405 24.652 3.00443 24.2989 3.00443 23.8635C3.00443 23.428 3.3405 23.075 3.75506 23.075C4.16962 23.075 4.50569 23.428 4.50569 23.8635Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </SvgIcon>
    )
}
